module.exports = __webpack_public_path__ + "img/hr-green-asterisk-19.ce20ac18.png";